import store from "@/store";
export default [
  {
    meta: {
      title: "Corp"
    },
    path: "/director/corp",
    name: "Corp",
    component: () => import("@/views/director/corp/Corp.vue")
  },
  {
    meta: {
      title: "CorpRegist"
    },
    path: "/director/corp/regist",
    name: "CorpRegist",
    component: () => import("@/views/director/corp/Regist.vue")
  }
];
